import { Trans } from '@lingui/macro'
import React from 'react'
import { InputField } from 'webbook-airways'

export default function InputFieldEmail(props) {
  return (
    <InputField
      autoComplete="new-password"
      label={<Trans>Email</Trans>}
      type="email"
      {...props}
    />
  )
}
